<section class="w3l-form-25">
    <div class="form-inner-cont">
        <div class="w3l-form-25">
            <h1>Patient list Consultation</h1>
            <p>Enter Booking Data below to stay updated </p>
        </div>
    </div>
  </section>

  <div id="w3l-appointment">
  <section class="appointment-section section-gap">
    <div class="wrapper">

                <form action="#" method="post">
                    <div class="fields-grid">

                      <div class="styled-input">
                        <div class="appointment-form-field" >
                          <label style="width: 10%;">Date</label>
                          <span class="fa fa-calendar" aria-hidden="true"></span>
                          <input type="date" [(ngModel)]="resDate" name="date" id="wdate" required=""  style="width: 30%;" (change)="retriveRes()">
                          <label style="width: 5%;"></label>
                          <label style="width: 10%;">Room Type</label>
                          <span class="fa fa-hotel" aria-hidden="true"></span>
                          <select id="roomtype" required="" name="roomtype"  [(ngModel)]="roomType" [value]="roomType" style="width: 30%;" (change)="retriveRes()" >
                            <option value="">Select*</option>
                            <option value ="Folllow up">Follow up</option>
                            <option value="Consultation">Consultation</option>
                            <option value="Treatment">Treatment</option>

                        </select>
                          <label style="width: 3%;"></label>
                          <label style="width: 10%;"> Room </label>
                          <span class="fa fa-hotel" aria-hidden="true"></span>
                            <select id="rooms" name="rooms" style="width: 30%;" required="" [(ngModel)]="roomCode" [value]="roomCode" (change)="retriveRes()" >
                              <option value="">Select *</option>
                              <option value="{{unit.roomCode}}" *ngFor="let unit of roomsList; let i = index">{{unit.roomName}}</option>
                          </select>
                           <label style="width: 3%;"></label>
                        <button type="button" id="English" name="English"   style="font-size: large;font-style: initial;font-family: Arial, Helvetica, sans-serif;width: 4%;height: 40px;color: rgb(10, 97, 7);border-radius: 15%;"  (click)="retriveRes()" matTooltip="Reshresh"><i class="fa fa-refresh"></i></button>

                        </div>

                      </div>

                  <!------- Doctors ----------->
                  <div class="styled-input">
                    <div class="appointment-form-field">
                      <label style="width: 10%;">Doctor</label>
                      <span class="fa fa-search" aria-hidden="true" style="cursor: grab;"  ></span>
                        <select id="doctor" name="doctor" required="" [(ngModel)]="docCode" [value]="docCode" style="width: 30%;" (change)="retriveRes()">
                          <option value="">Select *</option>
                          <option value="{{doc.docCode}}"  *ngFor="let doc of doctorsList; let i = index">{{doc.docName}}</option>
                      </select>
                      <label style="width: 5%;"></label>
                      <label style="width: 10%;">Type</label>
                          <span class="	fa fa-sitemap" aria-hidden="true" ></span>
                          <select id="department" required="" name="type" [(ngModel)]="resType" style="width: 30%;" (change)="retriveRes()" >
                            <option value="">Select*</option>
                            <option value="Consultation">إستشارة</option>
                            <option value="Visit">كشــف</option>
                            <option value="Treatment">Treatment</option>
                            <option value="Others">Others</option>
                        </select>
                      <label style="width: 3%;"></label>
                      <label style="width: 10%;">Status</label>
                          <span class="fa fa-street-view" aria-hidden="true"></span>
                          <select id="department" style="width: 30%;" required="" name="ststus"  [(ngModel)]="resStatus"  (change)="retriveRes()" >
                            <option value="">Select *</option>
                            <option value="Reservation">Reservation</option>
                            <option value="Attend">Attend (Waiting Room)</option>
                            <option value="Now">Now</option>
                            <option value="Done">Done</option>
                            <option value="Others">Others</option>
                        </select>
                         <label style="width: 7%;"></label>
                      </div>
                  </div>
                  </div>
              <table>
                  <thead>
                      <tr>
                          <th style="background-color:  rgb(78, 150, 245);color: white;width: 50px;text-align: center;">Patient ID</th>
                          <th style="background-color:  rgb(78, 150, 245);color: white;width: 110px;text-align: center;">Patient</th>
                          <th style="background-color:  rgb(78, 150, 245);color: white;width: 50px;text-align: center;">Time</th>
                          <th style="background-color:  rgb(78, 150, 245);color: white;width: 50px;text-align: center;">To</th>
                          <th style="background-color:  rgb(78, 150, 245);color: white;width: 100px;text-align: center;">Doctor</th>
                          <th style="background-color:  rgb(78, 150, 245);color: white;width: 110px;text-align: center;">Room</th>
                          <th style="background-color:  rgb(78, 150, 245);color: white;width: 50px;text-align: center;">P.O.</th>
                          <th style="background-color:  rgb(78, 150, 245);color: white;width: 55px;text-align: center;">Type</th>
                          <th style="background-color:  rgb(78, 150, 245);color: white;width: 60px;text-align: center;">Status</th>
                          <th style="background-color:  rgb(78, 150, 245);color: white;width: 60px;text-align: center;">Select</th>

                        </tr>
                  </thead>
                  <tbody>
                      <tr *ngFor="let res of reservationList; let i = index"  style="cursor: grabbing;">
                        <td data-column="Patient ID" (click)="ProgStep(res)">{{res.patientcode}}</td>
                        <td data-column="Patient Name" (click)="ProgStep(res)">{{res.patientname}}</td>
                        <td  data-column="Reservation Time" style="text-align: center;" (click)="ProgStep(res)">{{res.restime}}</td>
                        <td data-column="To Time" style="text-align: center;" (click)="ProgStep(res)">{{res.restotime}}</td>
                        <td data-column="Doctor Name" (click)="ProgStep(res)">{{res.resdocname}}</td>

                        <td data-column="Room" (click)="ProgStep(res)">{{res.roomname}}</td>
                        <td data-column="Room" (click)="ProgStep(res)">{{res.docnumber}}</td>
                        <td data-column="type" (click)="ProgStep(res)">{{res.restype}}</td>
                        <td data-column="stat" (click)="ProgStep(res)" [ngStyle]="{'color':  stylebackColor[i]}" style="font-weight: bold;">{{res.resstatus}} </td>

                        <td data-column="Select" style="text-align: center;">
                          <select class="appointment-form-field" id="resresstatus" style="width: 100%;" (change)="Chang_Status(res)"  required="" name="resststus"  [(ngModel)]="res.resstatus"  [value]="res.resstatus"  >
                          <option value="">Select *</option>
                          <option value="Reservation">Reservation</option>
                          <option value="Attend">Attend</option>
                          <option value="Now">Now</option>
                          <option value="Done">Done</option>
                          <option value="Others">Others</option>
                          </select>
                    </td>

                      </tr>


                  </tbody>

              </table>
                </form>

        </div>

  </section>

  </div>





